module.exports = __webpack_public_path__ + "img/image12-1.c1272fcf.jpeg";